import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';

import QuantityColumn from '../../../components/columns/quantity-column';
import { messages } from '../messages';

const QuantityColumnContainer = ({ fulfillmentId }) => {
  const { fulfillmentPlanId } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { items = [] } = useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId })) ?? {};

  const quantity = items.reduce((sum, item) => sum + (item.quantity || 0), 0);

  return <QuantityColumn quantity={quantity} />;
};

QuantityColumnContainer.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const Quantity = {
  getMessageDescriptor: () => messages.quantity,
  id: 'quantity',

  render: (data) => {
    return <QuantityColumnContainer fulfillmentId={data.id} />;
  },
};
